// extracted by mini-css-extract-plugin
export default {"loginOptions":"SY5XWnrxIrwtUIt3xyji"};